import { useCurrentUserQuery } from "@common/utils/graphql";
import { useMemo } from "react";

type CurrentUserQueryOptions = Parameters<typeof useCurrentUserQuery>[0];

export const useCurrentUser = (params?: CurrentUserQueryOptions) => {
  const { data, loading: currentUserLoading } = useCurrentUserQuery(params);

  const maybeCurrentUser = useMemo(() => {
    if (data?.currentUser?.__typename !== "QueryCurrentUserSuccess") {
      console.error("useCurrentUser: currentUser is undefined");
      return undefined;
    }

    return data.currentUser.data;
  }, [data]);

  return { maybeCurrentUser, currentUserLoading };
};
